export default "/etc.clientlibs/des/ploom/clientlibs/publish/des-react-hybrid/resources/7d69f9a78088f82ca748fae03b158b9a.png";